var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29134 18.8724H13.2913C17.458 18.8724 19.1247 17.2057 19.1247 13.0391V8.03905C19.1247 3.87239 17.458 2.20572 13.2913 2.20572H8.29134C4.12467 2.20572 2.45801 3.87239 2.45801 8.03905V13.0391C2.45801 17.2057 4.12467 18.8724 8.29134 18.8724Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0166 16.3307L7.12493 13.5724C7.78327 13.1307 8.73327 13.1807 9.32493 13.6891L9.59993 13.9307C10.2499 14.4891 11.2999 14.4891 11.9499 13.9307L15.4166 10.9557C16.0666 10.3974 17.1166 10.3974 17.7666 10.9557L19.1249 12.1224M8.2916 8.8724C8.73363 8.8724 9.15755 8.6968 9.47011 8.38424C9.78267 8.07168 9.95827 7.64776 9.95827 7.20573C9.95827 6.7637 9.78267 6.33978 9.47011 6.02722C9.15755 5.71466 8.73363 5.53906 8.2916 5.53906C7.84957 5.53906 7.42565 5.71466 7.11309 6.02722C6.80053 6.33978 6.62494 6.7637 6.62494 7.20573C6.62494 7.64776 6.80053 8.07168 7.11309 8.38424C7.42565 8.6968 7.84957 8.8724 8.2916 8.8724Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/imageIcon.99737591ed2381dceec98e43912b24c0.svg";
export { ForwardRef as ReactComponent };